import { render, staticRenderFns } from "./TenantRegistrationNew.vue?vue&type=template&id=125b1a36&scoped=true"
import script from "./TenantRegistrationNew.vue?vue&type=script&lang=js"
export * from "./TenantRegistrationNew.vue?vue&type=script&lang=js"
import style0 from "./TenantRegistrationNew.vue?vue&type=style&index=0&id=125b1a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b1a36",
  null
  
)

export default component.exports